function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.3959 10.0363C32.4056 7.7456 30.5676 6.75 29.0965 5.95295C28.1093 5.41814 27.2877 4.97284 27.3015 4.28539C27.313 3.7655 27.7928 3.21232 28.8443 3.07058C29.3642 3.00057 30.801 2.94606 32.4291 3.71958L33.0678 0.643268C32.1924 0.315036 31.067 0 29.6658 0C26.0717 0 23.5417 1.97226 23.5217 4.79552C23.4976 6.88485 25.327 8.04916 26.7052 8.74407C28.1213 9.45505 28.5966 9.91125 28.5914 10.5471C28.5805 11.5209 27.4614 11.9501 26.4151 11.9673C24.6413 11.9954 23.5893 11.4887 22.7563 11.087L22.6801 11.0503L22.0219 14.2293C22.871 14.6322 24.439 14.9828 26.0654 15C29.886 15 32.3839 13.053 32.3959 10.0363ZM22.531 0.265114L19.524 14.7733H15.8875L18.8951 0.265114H22.531ZM37.8291 9.63294L39.7434 4.18554L40.8453 9.63294H37.8291ZM45.25 14.7733H41.887L41.4478 12.606H36.7828L36.0243 14.7733H32.2067L37.6629 1.32957C37.9243 0.68401 38.5131 0.265114 39.2108 0.265114H42.3147L45.25 14.7733ZM11.4438 14.7733L17.3351 0.265114H13.5157L9.73135 10.1402L8.20004 1.74446C8.0206 0.806814 7.31142 0.265114 6.52313 0.265114H0.335424L0.25 0.686304C1.5193 0.971499 2.96288 1.43057 3.83717 1.92062C4.37207 2.22016 4.52458 2.48241 4.70058 3.19511L7.60037 14.7733H11.4438Z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 22.75,
  y1: 0,
  x2: 22.75,
  y2: 15,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#1261A3"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#115187"
})));

var SvgVisaLogo = function SvgVisaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 46,
    height: 15,
    viewBox: "0 0 46 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVisaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa_logo.fea27093.svg";
export { ForwardRef as ReactComponent };